import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import styled from "styled-components";

export const GroupWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const GroupTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin: 3px 0 0 10px;
`;

const GroupContentWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
`;

export const GroupItemText = styled.p<{ isDisabled?: boolean }>`
    margin: 0;
    ${setFontVariant("input2")}
    ${({ isDisabled = false }) =>
        isDisabled ? `color: ${colorsPalettes.carbon[100]}` : `color: ${colorsPalettes.carbon[500]}`};
`;

export const GroupItemSubText = styled.p<{ isDisabled?: boolean }>`
    margin: 0;
    ${setFontVariant("listItem3")}
    ${({ isDisabled = false }) =>
        isDisabled ? `color: ${colorsPalettes.carbon[100]}` : `color: ${colorsPalettes.carbon[300]}`};
`;

export const DropdownSegmentItemWrapper = styled.div`
    display: flex;
    align-items: center;
    margin: 6px 16px;
    justify-content: space-between;
`;

const DropdownContainer = styled.div`
    margin-bottom: 25px;
    width: 400px;
`;

const SegmentsTitleWrapper = styled.div`
    display: flex;
    align-items: center;
    max-width: 400px;
    justify-content: space-between;
`;

const SelectedSegmentsCount = styled.span<{ isMaxReached: boolean }>`
    ${setFontVariant("subsectionTitle")}
    margin: 10px 0 20px 0;
    ${({ isMaxReached }) =>
        isMaxReached ? `color: ${colorsPalettes.red[400]}` : `color: ${colorsPalettes.carbon[400]}`}
`;

const ChangeNotAvaliableWrapper = styled.div`
    display: flex;
    padding: 10px 10px 10px 0;
    color: ${colorsPalettes.red[400]};
    align-items: center;
`;

const ChangeNotAvaliableText = styled.p`
    margin: 0 0 0 10px;
`;

const DropdownWrapper = styled.div`
    display: flex;
`;

const SegmentNameLabel = styled.div`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;

const SegmentTypeBadge = styled.span`
    display: inline;
    padding: 3px 3px 3px;
    color: ${colorsPalettes.carbon[400]};
    background: ${colorsPalettes.carbon[50]};
    border-radius: 4px;
    font-size: 8px;
    line-height: 8px;
    text-transform: uppercase;
`;
